import React from "react";
import "./checkpoint-result.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppButtonComponent from "../../../../../components/form/app-button";
import { CheckpointStatus } from "../../../types/checkpoint.types";

interface ExamResultProps {
  score: number;
  percentage: number;
  passingScore: number;
  totalQuestions: number;
  result: "FAILED" | "PASSED";
  onRepeat: () => void;
}

const CheckpointResultComponent = ({
  score,
  percentage,
  passingScore,
  totalQuestions,
  result,
  onRepeat,
}: ExamResultProps) => {
  const { t } = useTranslation();

  return (
    <Box className="checkpoint__result">
      <Box
        className="global__box__content"
        style={{ padding: "1.5rem 2rem", marginBottom: "1.9rem" }}
      >
        <Typography variant="h3" className="font-weight-bold text-center mb-4">
          {t("EDUCATION_PAGE.CHECKPOINT_RESULT")}
        </Typography>
        <Box className="result__content">
          <Box className="result__content__item">
            <Typography variant="body1">
              {t("EDUCATION_PAGE.YOUR_SCORE")}
            </Typography>
            <Typography variant="h4" className="font-weight-bold">
              {percentage}% ({score}/{totalQuestions} {t("CORRECT")})
            </Typography>
          </Box>
          <Box className="result__content__item">
            <Typography variant="body1">
              {t("EDUCATION_PAGE.MINIMUM_SCORE")}
            </Typography>
            <Typography variant="h4" className="font-weight-bold">
              {passingScore}%
            </Typography>
          </Box>
          <Box className="result__content__item">
            <Typography variant="body1">
              {t("EDUCATION_PAGE.RESULT")}
            </Typography>
            <span
              className="result__label"
              style={{
                backgroundColor:
                  result === CheckpointStatus.FAILED
                    ? "var(--danger)"
                    : "var(--success)",
              }}
            >
              {result === CheckpointStatus.FAILED
                ? t("NOT_PASSED")
                : t("ACHIEVED")}
            </span>
          </Box>
        </Box>
      </Box>
      {result === "FAILED" && (
        <Box className="action">
          <Typography variant="h3" className="font-weight-bold">
            {t("EDUCATION_PAGE.REPEAT_CHECKPOINT")}
          </Typography>
          <AppButtonComponent
            variant="contained"
            color="primary"
            onClick={onRepeat}
          >
            {t("EDUCATION_PAGE.REPEAT")}
          </AppButtonComponent>
        </Box>
      )}
    </Box>
  );
};

export default CheckpointResultComponent;
